// imports

// local imports
import {
  UPDATE_CART,
  REMOVE_ITEM,
  CLEAR_CART,
  SET_CART_DATA,
  SET_CART_STATUS,
} from '../helpers/types';

const INITIAL_STATE = {
  cartItems: [],
  isLoading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_CART:
      return { ...state, cartItems: action.payload };
    case REMOVE_ITEM:
      return {
        ...state,
        cartItems: state.cartItems.filter(item => item.Material !== action.payload),
      };
    case CLEAR_CART:
      return { ...state, cartItems: [] };

    case SET_CART_DATA:
      return { ...state, cartItems: action.payload };
    case SET_CART_STATUS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
